<div class="c-content u-no-ph@md-and-up u-hidden@up-to-md" *ngIf="vm.user?.businessUserType==='BUSINESS_CLIENT'">
	<div class="o-grid">
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@lg-and-up o-grid__cell--right u-no-p">
			<form class="c-form">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--slim">
						<div class="c-form__group c-form__group--icon u-osb-sm">
							<i class="o-icon o-icon--schedule c-form__icon" aria-hidden="true"></i>
							<input-datepicker [opens]="'left'" [isSmall]="true" [parentEl]="vm.element" [minDate]="'01.01.1970'" [hasDropdowns]="true" [isAutoApplying]="true" [(model)]="vm.filterData.created" [placeholder]="'Common.Choose_Date_Range' | translate" [isClearable]="true"></input-datepicker>
						</div>
					</div>
					<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed u-no-p">
						<a id="transactionDownloadLink" href="{{vm.csvDownloadUrl}}" target="_self" download="transactions-report.csv" class="c-button c-button--s1 c-button--fit">{{ 'Common.Download' | translate }}</a>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="c-content c-content--wrapper" [ngClass]="{'u-no-ph u-no-pb': vm.user?.businessUserType==='BUSINESS_CLIENT', 'u-no-p': vm.user?.businessUserType!=='BUSINESS_CLIENT'}" [ngStyle]="vm.loading && {'min-height': '300px'}" id="{{vm.uid}}">
	<div *ngIf="!vm.loading">
		<div *ngIf="vm.transactions?.length">
			<div class="c-content c-content--border-bottom u-no-pt u-no-ph@md-and-up u-hidden@up-to-md">
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
						<p class="c-text c-text--gray" aria-hidden="true">{{'Wallet.Table.Date' | translate}}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
						<p class="c-text c-text--gray" aria-hidden="true">{{ vm.labels.col2 }}</p>
					</div>
					<div class="o-grid__cell u-no-p" [ngClass]="{'o-grid__cell--w-20': vm.showIncomeOnly, 'o-grid__cell--w-40': !vm.showIncomeOnly}">
						<p class="c-text c-text--gray" aria-hidden="true">{{'Wallet.Table.Name' | translate}}</p>
					</div>
					<div class="o-grid__cell u-no-p o-grid__cell--w-15">
						<p class="c-text c-text--gray" aria-hidden="true">{{ vm.labels.col4 }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-10 u-no-p" *ngIf="vm.showIncomeOnly">
						<p class="c-text c-text--gray c-text--right" aria-hidden="true">{{'Wallet.Table.Seller_Fee' | translate}}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-10 u-no-p" *ngIf="vm.showIncomeOnly">
						<p class="c-text c-text--gray c-text--right" aria-hidden="true">{{'Wallet.Table.Minudoc_Fee' | translate}}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
						<p class="c-text c-text--gray c-text--right" aria-hidden="true">{{ vm.labels.col5 }}</p>
					</div>
				</div>
			</div>
			<ul class="c-list">
				<li *ngFor="let transaction of vm.transactions | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $index=index">
					<div class="c-content c-content--border-bottom u-no-ph@md-and-up">
						<div class="o-grid o-grid--wrap">
							<div class="o-grid__cell o-grid__cell--w-15@md-and-up u-no-p o-grid__cell--w-35 o-grid__cell--o2@md-and-up">
								<span class="u-sr-only">{{ 'Wallet.Table.Transaction' | translate }}:</span>
								<p id="transactionCol2_{{$index}}" class="c-text c-text--sm@up-to-md" [ngClass]="{'c-text--s3': vm.showIncomeOnly && !transaction.wired}">{{ transaction.col2 }}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-20@md-and-up u-no-p o-grid__cell--w-65 o-grid__cell--o1@md-and-up">
								<span class="u-sr-only">{{'Wallet.Table.Date' | translate}}:</span>
								<p id="transactionDate_{{$index}}" class="c-text c-text--sm@up-to-md c-text--right@up-to-md">{{ transaction.created | date:'dd.MM.yyyy HH:mm:ss' }}</p>
							</div>
							<div class="o-grid__cell u-no-p o-grid__cell--w-15@md-and-up o-grid__cell--w-50 o-grid__cell--o4 u-ost-md@up-to-md" [ngClass]="{'o-grid__cell--w-100': vm.showIncomeOnly}">
								<span class="u-sr-only">{{ vm.labels.col4 }}:</span>
								<p id="transactionCol4_{{$index}}" class="c-text c-text--sm@up-to-md">{{ transaction.col4 }}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-100 u-no-p o-grid__cell--o3@md-and-up" [ngClass]="{'o-grid__cell--w-20@md-and-up': vm.showIncomeOnly, 'o-grid__cell--w-40@md-and-up': !vm.showIncomeOnly}">
								<span class="u-sr-only">{{'Wallet.Table.Name' | translate}}:</span>
								<p id="transactionCol3_{{$index}}" class="c-text u-ost-md@up-to-md c-text--bold@up-to-md">{{ transaction.col3 }}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-33 o-grid__cell--w-10@md-and-up u-no-p o-grid__cell--o4 u-ost-md@up-to-md" *ngIf="vm.showIncomeOnly">
								<p id="transactionSellerFee_{{$index}}" class="c-text c-text--right@md-and-up c-text--sm@up-to-md c-text--s10">
									<span class="u-hidden@md-and-up">{{'Wallet.Table.Seller_Fee' | translate}}: </span>+{{ transaction.amount }}{{ transaction.currency | currency }}
								</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-33 o-grid__cell--w-10@md-and-up u-no-p o-grid__cell--o4 u-ost-md@up-to-md" *ngIf="vm.showIncomeOnly">
								<p id="transactionOurFee_{{$index}}" class="c-text c-text--right@md-and-up c-text--sm@up-to-md c-text--s10 c-text--center@up-to-md">
									<span class="u-hidden@md-and-up">{{'Wallet.Table.Minudoc_Fee' | translate}}: </span>-{{ transaction.fee || 0 }}{{ transaction.currency | currency }}
								</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-10@md-and-up u-no-p o-grid__cell--o4 u-ost-md@up-to-md" [ngClass]="{'o-grid__cell--w-50': !vm.showIncomeOnly, 'o-grid__cell--w-33': vm.showIncomeOnly}">
								<span class="u-sr-only">{{'Wallet.Table.Amount' | translate}}:</span>
								<p id="transactionAmount_{{$index}}" class="c-text c-text--right c-text--main c-text--sm@up-to-md" [ngClass]="{ 'c-text--main': transaction.direction === 'INCOMING', 'c-text--s3': transaction.direction === 'OUTGOING' }"><span class="c-text c-text--gray u-hidden@md-and-up" *ngIf="vm.showIncomeOnly">{{ vm.labels.col5 }}: </span>{{ transaction.col5 }}{{ transaction.currency | currency }}</p>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<item-no-content *ngIf="!vm.transactions?.length"></item-no-content>
	</div>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
